import {
  PasswordResetV2,
  CheckCustomerForm,
  EncryptedTokenAssertionForm,
  AxfoodUpdatePwdForm,
  UpdatePwdTokenForm,
} from '@occ/api-client';

const passwordResetApi = new PasswordResetV2({ baseUrl: '' });

export const checkExistingCustomer = (form: CheckCustomerForm) => passwordResetApi.checkCustomerExistsV2(form);

export const checkExistingB2bCustomer = (organisationNumber: string) =>
  passwordResetApi.checkExistingB2BCustomerV2({ organisationNumber });

export const checkB2bCustomerBySapId = (sapid: string) => passwordResetApi.checkExistingB2BCustomerBySapIdV2({ sapid });

export const verifySmsToken = (form: EncryptedTokenAssertionForm) => passwordResetApi.verifySmsTokenV2(form);

export const validateEmailToken = (token: string) =>
  passwordResetApi.validateEmailTokenV2({ token } as UpdatePwdTokenForm);

export const changePassword = (
  token?: string,
  pwd?: string,
  checkPwd?: string,
  rememberMe?: boolean,
  pwdKey?: string,
  checkPwdKey?: string
) =>
  passwordResetApi.changePasswordV2({
    token,
    pwd: pwd!,
    checkPwd,
    rememberMe,
    pwdKey,
    checkPwdKey,
  } as AxfoodUpdatePwdForm);
